export default {
  math: 'Matemática',
  language: 'Lengua',
  art: 'Arte',
  transversal: 'Transversal',
  socialSciences: 'Ciencias sociales',
  naturalSciences: 'Ciencias naturales',
  languages: 'Idiomas',
  technology: 'Tecnología',
  physicalEducation: 'Educación física'
}

export const en = {
  math: 'Maths',
  language: 'Grammar',
  art: 'Art',
  transversal: 'Transversal',
  socialSciences: 'Social science',
  naturalSciences: 'Natural science',
  languages: 'Languages',
  technology: 'Technology',
  physicalEducation: 'Physical education'
}

export const ca = {
  math: ' Matemàtica',
  language: 'Llengua',
  art: 'Art',
  transversal: 'Transversal',
  socialSciences: 'Ciències socials',
  naturalSciences: 'Ciències naturals',
  languages: 'Idiomes',
  technology: 'Tecnologia',
  physicalEducation: 'Educació física'
}
